import { useState } from "react";
import {
  ResponseGetNoticeResponse,
  NoticeApi,
  RequestUpdateNoticeRequest,
  NoticeUpdateNoticePostRequest,
} from "../../services/OpenAPI";
import { createConfiguration } from "./common";

export const useApiUpdateNotice = () => {
  const [noticeList, setNoticeList] = useState<
    ResponseGetNoticeResponse[] | null
  >([]);
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const updateNotice = async (req: RequestUpdateNoticeRequest) => {
    setIsLoading(true);
    setError(null);

    try {
      const config = createConfiguration();
      const request: NoticeUpdateNoticePostRequest = {
        req,
      };
      const api = new NoticeApi(config);
      const response = await api.noticeUpdateNoticePost(request);
      setNoticeList(response);
      return response;
    } catch (err: any) {
      setError("お知らせの更新に失敗しました");
      console.error(err);
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  return { updateNotice, noticeList, error, isLoading };
};
